<template>
    <portlet
            :icon="'fi flaticon-export'"
            :title="'Maak een export'"
    >
        <div slot="portletBody">
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label for="daterangeFrom">Begin datum</label>
                        <div class="input-group addon" v-if="!dateFrom">
                            <span class="input-group-addon">
                                <i class="fi flaticon-calendar"></i>
                            </span>
                        </div>
                        <datepicker
                                id="daterangeFrom"
                                v-model="dateFrom"
                                :fullMonthName="true"
                                format="dd-MM-yyyy"
                                :disabledDates="disabledDates"
                                :input-class="'form-control'">
                        </datepicker>
                    </div>
                </div>

                <div class="col-6">
                    <div class="form-group">
                        <label for="daterangeTo">Eind datum</label>
                        <div class="input-group addon">
                            <span class="input-group-addon"  v-if="!dateTo">
                                <i class="fi flaticon-calendar"></i>
                            </span>
                        </div>
                        <datepicker
                                id="daterangeTo"
                                v-model="dateTo"
                                :fullMonthName="true"
                                :format="'dd-MM-yyyy'"
                                :disabledDates="disabledDatesTo"
                                :input-class="'form-control'">
                        </datepicker>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Product(en)   <span style="opacity:0.6;font-weight: 300;">Bij geen producten worden alle producten geëxporteerd</span></label>
                        <multiselect
                                v-model="value"
                                :options="products"
                                :multiple="true"
                                :close-on-select="false"
                                :clear-on-select="false"
                                :preserve-search="true"
                                label="name"
                                track-by="id"
                                placeholder="Selecteer product(en)"
                                selectLabel="Druk enter om te selecteren"
                                selectedLabel="Geselecteerd"
                                deselectLabel="Druk enter om te deselecteren"
                                :taggable="true"
                                @tag="addTag">
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-center">
                    <button class="btn btn-primary" @click="exportData">
                        Exporteer
                    </button>
                </div>
            </div>
        </div>
    </portlet>
</template>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Datepicker from 'vuejs-datepicker';
    import {nl} from 'vuejs-datepicker/dist/locale'
    import Multiselect from 'vue-multiselect'

    export default {
        components: {
            Datepicker,
            Multiselect
        },
        data() {
            return {
                dateFrom: '',
                dateTo: '',
                nl: nl,
                disabledDates: {
                    from: new Date(new Date().setDate(new Date().getDate() - 1))
                },
                productName: '',
                products: [],
                value: []
            }
        },
        methods: {
            ...mapActions('exports', [
                'exportDataApi'
            ]),
            addTag(newTag) {
                const tag = {
                    name: newTag,
                    code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
                }
                this.options.push(tag)
                this.value.push(tag)
            },
            exportData() {
                var productArray = [];

                this.value.forEach(item=>{
                    productArray.push(item.name);
                })
                // for (var i = 0; i < this.value.length; i++) {
                //     productArray.push(this.value[i].name);
                // }

                let exportData = {
                    startDate: moment(this.dateFrom).format('YYYY-MM-DD'),
                    endDate: moment(this.dateTo).format('YYYY-MM-DD'),
                    product: productArray
                };


                this.exportDataApi(exportData);
            },
        },
        computed: {
            ...mapGetters('users', [
                'getMe'
            ]),
            disabledDatesTo() {
                let date = {
                    to: new Date(moment(this.dateFrom)),
                    from: new Date(new Date().setDate(new Date().getDate()))
                }
                return date
            }
        },
        created() {
            PORTAL_API.get('/companies/' + this.getMe.company.id + '/export/productlist').then(res => {
                this.products = _.orderBy(_.uniqBy( res.data, 'name'), ['name'],['asc']);
            })

        }
    }
</script>
<style lang="scss" scoped>
    .form-group label {
        font-weight: 700;
    }

    .disabled {
        opacity: 0.4;
        &:hover {
            cursor: not-allowed;
        }
    }

    .vdp-datepicker input {
        padding-left: 40px;
    }

    .multiselect {
        .multiselect__select {
            height: 45px;
        }
        .multiselect__tags {
            -webkit-border-radius: 0;
            -moz-border-radius: 0;
            border-radius: 0;
            background: #222235;
            padding: 12px 40px 1px 13px;
            border-color: #2b3553;

            .multiselect__input,
            .multiselect__single,
            .multiselect__spinner {
                background: #222235;
            }
            .multiselect__input {
                font-size: 1.4rem;
                margin-bottom: 12px;
                color: #ffffff;
                padding: 0;
            }
            .multiselect__placeholder {
                padding-top: 0;
            }

        }
        .multiselect__option {
            font-size: 1.4rem;
        }
    }
</style>
